// Recovered compiled webpack factory 87254. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { Qe: () => r, R1: () => i, Vy: () => n });
  let r = "squircle-lg border border-black/[0.08] dark:border-white/[0.10]",
    n = "mx-auto w-full max-w-[1180px] px-6 lg:px-10",
    i = "mt-48";
}
